import cx from 'classnames';
import React, { useEffect, useState } from 'react';
import styles from './item.module.css';
import { Button } from 'app/shared/button';
import { useCurrencyService } from 'hooks/sales/currency';
import { toReadableNumber } from 'app/shared/utils/number';
import { useSubscriptionService } from 'hooks/sales/subscription';

export const SubscriptionPurchaseItem = ({
  contact_bracket = { min: 0, max: 0 },
  currency = {},
  is_selected,
  module,
  renewal_period = 'month',
  tax_rates = {},
  tenant_class = 'old',
  onDisable = () => {},
  onSelect = () => {},
  onPricingChange = () => {}
}) => {
  const { getCurrencySymbol } = useCurrencyService();
  const { determinePaymentDetails } = useSubscriptionService();

  const [discount_rate, setDiscountRate] = useState(0);
  const [is_activated, setIsActivated] = useState(false);
  const [price, setPrice] = useState(0);
  const [resources, setResources] = useState({});

  useEffect(() => {
    if (!module || !module.pricing) return;
    const sorted_pricing = module.pricing.sort(
      (a, b) => a.contact_bracket.min - b.contact_bracket.min
    );
    const target_pricing = sorted_pricing.find((pricing) => {
      const { min, max } = pricing.contact_bracket;
      return contact_bracket.min === min && contact_bracket.max === max;
    });

    if (!target_pricing) {
      onDisable(module.tier);
      setIsActivated(false);
      return;
    }

    setIsActivated(true);
    setResources(target_pricing.resources);
    const payment_details = determinePaymentDetails({
      currency,
      user_tenure: tenant_class,
      selected_pricing: target_pricing,
      tax_rates,
      renewal_period,
      discount_rate
    });
    setDiscountRate(payment_details?.discount_rate || 0);
    setPrice(payment_details?.discounted_price);
    is_selected && onPricingChange({ ...payment_details, pricing: target_pricing });
  }, [module.tier, is_selected, currency, contact_bracket, renewal_period]);

  const handleModuleSelection = () => {
    onSelect(module);
  };

  const replacePlaceholder = (text) => {
    const keys = Object.keys(resources);
    let replacedText = text;
    keys.forEach((key) => {
      const regex = new RegExp(`@${key}_volume`, 'g');
      replacedText = replacedText.replace(regex, toReadableNumber(resources[key]));
    });
    return replacedText;
  };

  return (
    <div className={cx(styles.wrapper)} onClick={handleModuleSelection}>
      <div
        className={cx(styles.innerWrapper, {
          [styles.isSelected]: is_selected,
          [styles.isDisabled]: !is_activated,
          [styles.isPopular]: module.tier === 'professional'
        })}
      >
        <div className={styles.label}>
          {module.tier === 'professional' && <span>Most Popular</span>}
        </div>
        <div className={styles.content}>
          <div className={styles.titleWrapper}>
            <h4>{module.title}</h4>
            {discount_rate > 0 && <span className={styles.discountTag}>{discount_rate}% Off</span>}
          </div>
          <p className={styles.description}>{module.description}</p>
          <div className={styles.priceSection}>
            <span className={styles.price}>
              {getCurrencySymbol(currency.code)} {toReadableNumber(price)}
            </span>{' '}
            per {renewal_period}
          </div>
          <div className={styles.cta}>
            <Button
              className={cx(styles.selectBtn, { [styles.selected]: is_selected })}
              text={!is_activated ? 'Bracket exceeded' : is_selected ? 'Selected' : 'Select plan'}
              onClick={handleModuleSelection}
            />
          </div>
          <div className={styles.benefits}>
            {module.benefits.slice(0, 7).map((benefit, index) => (
              <div key={index} className={styles.benefit}>
                <span className={styles.checkIcon}>✓</span>&nbsp;
                <span>{replacePlaceholder(benefit)}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
